module.exports = __webpack_public_path__ + "static/img/当心有毒气体.6993f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/当心有毒气体.png
// module id = otr2
// module chunks = 1